import {
  REQUEST_IS_LOGGED_IN,
  RECEIVE_IS_LOGGED_IN,
  RECEIVE_IS_LOGGED_IN_TELMEX,
  REQUEST_LOGIN,
  RECEIVE_LOGIN,
  REQUEST_FAVORITED_VOD,
  REQUEST_FAVORITED_CHANNELS,
  UPDATE_FAVORITED_VOD,
  UPDATE_FAVORITED_CHANNELS,
  DELETE_FAVORITED_VOD,
  DELETE_FAVORITED_CHANNELS,
  RECEIVE_LOGIN_DYNAMIC,
  RECEIVE_SUBSCRIPTION,
  REQUEST_AUTHDEVICE,
  RECEIVE_AUTHDEVICE,
  SET_LASTTOUCH_SEEN,
  SET_LASTTOUCH_FAVORITED,
  ACTIVE_MARQUEE,
  REQUEST_PUSH_SESSION,
  RECEIVE_PUSH_SESSION,
  SET_LASTTOUCH_PROFILE,
  SET_LASTTOUCH_REMINDER,
  SET_LASTTOUCH_LIVECHANNEL,
  SET_ACCEPTED_TERM,
  SET_VALID_EMAIL,
  CONTINUE_PROCESS_LOGIN_BY_TOKEN,
  RECEIVE_USER_TOKEN,
} from '../actions/user';
import {
  isLoggedIn,
  smartCardLogin,
  fetchFavoriteLoader,
  loginDynamic,
  authdevice,
  pushSession,
  authdeviceV1,
  loginByToken
} from '../requests/loader';
import DeviceStorage from '../components/DeviceStorage/DeviceStorage';
import Utils, { setYouboraData } from "../utils/Utils";
import settings, { IPTV, OTT } from '../devices/all/settings';
import LoadingIptvOttFlow from '../AAF/LoaderExp/LoadingIptvOttFlow';
import AAF from 'src/AAF/AAF';
import getAppConfig from '../config/appConfig';

const SUSC = 'susc';
const NO_SUSC = 'no_susc';
const ANONYMOUS = 'anonymous';

export const initialState = {
  isFetching: false,
  isLoggedIn: false,
  isAnonymous: true,
  isSusc: false,
  userStatus: ANONYMOUS,
  type: OTT,
  isSuspendedAccount: false, //Usuarios anonimos no pueden estar bloqueados
};

export const requestLogin = () => ({ type: REQUEST_LOGIN });
export const requestAuthDevice = () => ({ type: REQUEST_AUTHDEVICE });
export const activeMarquee = value => ({ type: ACTIVE_MARQUEE, activeMarquee: value });
export const activeProcessLoginBytoken = value => ({ type: CONTINUE_PROCESS_LOGIN_BY_TOKEN, activeProcessLoginBytoken: value });
export const receiveAuthDevice = user => ({ type: RECEIVE_AUTHDEVICE, user });
export const requestIsLoggedIn = () => ({ type: REQUEST_IS_LOGGED_IN });
export const receiveIsLoggedIn = user => ({ type: RECEIVE_IS_LOGGED_IN, user });
export const receiveIsLoggedInTelmex = (user, result) => ({
  type: RECEIVE_IS_LOGGED_IN_TELMEX,
  user,
  result
});
export const receiveUserToken = user_token => ({ type: RECEIVE_USER_TOKEN, user_token})
export const receiveSubscription = subscriptions => ({
  type: RECEIVE_SUBSCRIPTION,
  subscriptions
});
export const setLastTouchSeen = lasttouch => ({
  type: SET_LASTTOUCH_SEEN,
  lasttouch
});

export const updateLastTouchSeen = lasttouch => dispatch => {
  dispatch(setLastTouchSeen(lasttouch));
}

export const setLastTouchFavorited = lasttouch => ({
  type: SET_LASTTOUCH_FAVORITED,
  lasttouch
});

export const updateLastTouchFavorited = lasttouch => dispatch => {
  dispatch(setLastTouchFavorited(lasttouch));
}
export const setLastTouchProfile = lasttouch => ({
  type: SET_LASTTOUCH_PROFILE,
  lasttouch
});
export const setLastTouchReminder = lasttouch => ({
  type: SET_LASTTOUCH_REMINDER,
  lasttouch
});

export const setLastTouchLiveChannel = lasttouch => ({
  type: SET_LASTTOUCH_LIVECHANNEL,
  lasttouch
});

export const receiveLoginDynamic = user => ({ type: RECEIVE_LOGIN_DYNAMIC, user });
export const requestFavoritedVOD = groups => ({ type: REQUEST_FAVORITED_VOD, groups });
export const requestFavoritedChannels = groups => ({
  type: REQUEST_FAVORITED_CHANNELS,
  groups
});
export const updateFavorited = group => ({ type: UPDATE_FAVORITED_VOD, group });
export const updateFavoritedChannels = group => ({ type: UPDATE_FAVORITED_CHANNELS, group });
export const deleteFavorited = groupId => ({ type: DELETE_FAVORITED_VOD, group: groupId });
export const deleteFavoritedChannels = groupId => ({
  type: DELETE_FAVORITED_CHANNELS,
  group: groupId
});

export const requestPushSession = () => ({ type: REQUEST_PUSH_SESSION });
export const receivePushSession = result => ({ type: RECEIVE_PUSH_SESSION, result });

export const fetchFavoriteVOD = (user, filter_list) => dispatch => {
  return fetchFavoriteLoader(user, filter_list)
    .then(result => {
      const groups = result.response ? result.response : [];
      dispatch(requestFavoritedVOD(result.response.groups));
    })
    .catch(err => {
      console.error('Error', err);
    });
};

export const activeMarquesina = value => dispatch => {
  dispatch(activeMarquee(value));
};

export const fetchFavoriteChannels = (user, filter_list) => dispatch => {
  return fetchFavoriteLoader(user, filter_list)
    .then(result => {
      const groups = result.response ? result.response : [];
      dispatch(requestFavoritedChannels(result.response.groups));
    })
    .catch(err => {
      console.error('Error', err);
    });
};

export const updateFavorite = groupId => dispatch => {
  dispatch(updateFavorited(groupId));
};

export const deleteFavorite = groupId => dispatch => {
  dispatch(deleteFavorited(groupId));
};

export const fetchIsLoggedIn = (from = null) => dispatch => {
  dispatch(requestIsLoggedIn());
  return isLoggedIn()
    .then(result => {
      AAF.Resilence.filterIsloggedin(result, from);
    })
    .catch(err => {
      console.error('isLoggedIn failed, user NOT logged in', err);
      // Se deja como estaba en ott
      AAF.Resilence.filterIsloggedin(null);
    });
};

export const cleanUserPtvUrl = () => (dispatch, getStore) => {
  const state = getStore();
  let {user}  = state;
  if(user && user.ptv_url){
    user = { ...user, ptv_url: null };
    dispatch(receiveIsLoggedIn(user));
  }
}

export const fetchLoginDynamic = email => (dispatch, getStore) => {
  const state = getStore();
  if (state.user.musicUser === undefined) {
    const loginRegisterMusicEnabled = Utils.getApaMetadataKey("loginRegister_music_enabled", '{"enable": false}', "enable");
    if(loginRegisterMusicEnabled) {
      const musicUserInStorage = JSON.parse(DeviceStorage.getItem('userCM'))
      return dispatch(receiveLoginDynamic(musicUserInStorage));
    } else {
      return loginDynamic(email)
      .then(result => {
        let user;
        const useCM_MW = settings.music_use_login_dynamic_cm_middleware;
        const entry = result.entry ? result.entry : {};
        if (useCM_MW) {
          user = result.response ? result.response : {};
          // Para guardar compatibilidad con el middleware anterior
          user.token = result.response.cm_access_token
            ? result.response.cm_access_token
            : '';
        } else {
          user = result.response ? result.response.profile : {};
          if (user.token) {
            user.countryCode = result.response.store.isoCountryCode;
          }
        }

        if (entry.device_id) {
          user.deviceId = entry.device_id;
        }
        dispatch(receiveLoginDynamic(user));
      })
      .catch(err => {
        console.error('loginDynamic failed, user NOT logged in', err);
        dispatch(receiveLoginDynamic(initialState));
      });
    }
  }

  dispatch(receiveLoginDynamic(state.user.musicUser));
};

export const fetchSmartCardLogin = () => dispatch => {
  dispatch(requestLogin());
  return smartCardLogin()
    .then(result => {
      const user = result.response ? result.response.data : {};
      dispatch(receiveAuthDevice(user));
    })
    .catch(err => {
      console.error('SmartcardLogin failed, user NOT logged in', err);
      dispatch(receiveAuthDevice(initialState));
    });
};

export const fetchAuthDevice = () => dispatch => {
  dispatch(requestAuthDevice());
  return authdevice()
    .then(result => {
      const user = result.response ? result.response : {};
      if (result.response) {
        DeviceStorage.setItem('fromAuthDevice', 'true');
      }
      user.subregion && DeviceStorage.setItem('sub_region', user.subregion);
      dispatch(receiveAuthDevice(user));
      Utils.setCustomAttribute();
    })
    .catch(err => {
      LoadingIptvOttFlow.setIsEnabled(true);
      console.error('fetchAuthDevice failed, user NOT logged in', err);
      DeviceStorage.setItem('fromAuthDevice', 'false');
      DeviceStorage.setItem('missingEmail', 'false');
      let user = initialState;

      if (
        err.completeError &&
        err.completeError.errors &&
        err.completeError.errors.code == '703000001'
      ){
        user = { ptv_url: err.completeError.response };
        DeviceStorage.setItem('missingEmail', 'true');
      }
      dispatch(receiveAuthDevice(user));
    });
};

const hasCRMExperienceToken = () => {
  const token = DeviceStorage.getItem('CMR_Experience_Token');
  if (token && token !== 'null' && token !== '') {
    return true;
  }
  return false;
}

//* Nueva funcionalidad para el authDevice v1
export const fetchAuthDeviceCMR = () => async dispatch => {
  dispatch(requestAuthDevice());
  console.log('[fetchAuthDeviceV1]:: start');

  try {
    const responseAPIData = await authdeviceV1();
    const userDataCRM = responseAPIData ? responseAPIData : {};
    console.log('[fetchAuthDeviceV1]:: success', responseAPIData, userDataCRM);
    dispatch(continueProcessLoginByToken(true));
  } catch (err) {
    console.log('[fetchAuthDeviceV1]:: failed, user NOT logged in', err);
    // Validate if CRM Experience Token exist
    if (hasCRMExperienceToken()) {
      // Continue with LoginByToken
      dispatch(continueProcessLoginByToken(true));
    } else {
      //* Error de la API authdeviceV1 mandara a la landing
      LoadingIptvOttFlow.setIsEnabled(true);
      DeviceStorage.setItem('fromAuthDevice', 'false');
      DeviceStorage.setItem('missingEmail', 'false');
      dispatch(continueProcessLoginByToken(false));
      AAF.Resilence.filterIsloggedin(null);
    }
  }
};

export const fetchLoginByToken = () => dispatch => {
  console.log('[loginByToken]:: start');
  const config = getAppConfig();

  return loginByToken()
    .then(result => {
      const userData = result.data ? result.data : {};
      console.log('[loginByToken]:: success', userData);

      if (userData) {
        //* Se obtiene el user_token y se guarda en el store
        DeviceStorage.setItem('user_token', userData.user_token);
        AAF.Database.setUserToken(userData.user_token);
        DeviceStorage.setItem('fromAuthDevice', 'true');
        userData.subregion && DeviceStorage.setItem('sub_region', userData.subregion);
        dispatch(receiveAuthDevice(userData));
        dispatch(receiveIsLoggedIn(userData));
        Utils.setCustomAttribute();
        //* Youbora: data para youbora
        setYouboraData(userData.email, userData.region, config.device_id, userData.subregion);
      }
    })
    .catch(err => {

        LoadingIptvOttFlow.setIsEnabled(true);
        console.error('[loginByToken]:: failed, userData NOT logged in', err);
        DeviceStorage.setItem('fromAuthDevice', 'false');
        DeviceStorage.setItem('missingEmail', 'false');
        let userData = initialState;


        AAF.Resilence.filterIsloggedin(null);
        dispatch(receiveAuthDevice(userData));
        dispatch(continueProcessLoginByToken(false));
    });
};

export const continueProcessLoginByToken = value => dispatch => {
  dispatch(activeProcessLoginBytoken(value));
};

export const fetchAuthDeviceEmailRegistration = (email, account, extraParams = {}) => dispatch => {
  dispatch(requestAuthDevice());
  return authdevice({email, account, ...extraParams})
    .then(result => {
      const user = result.response ? result.response : {};
      if (result.response) {
        DeviceStorage.setItem('fromAuthDevice', 'true');
      }
      user.subregion && DeviceStorage.setItem('sub_region', user.subregion);
      dispatch(receiveAuthDevice(user));
      Utils.setCustomAttribute();
    })
    .catch(err => {
      console.error('fetchAuthDevice failed, email NOT registered', err);
      throw err;
    });
};

export const fetchPushSession = user_id => dispatch => {
  dispatch(requestPushSession());
  return pushSession(user_id)
    .then(result => {
      dispatch(receivePushSession(result));
    })
    .catch(err => {
      console.error('pushSession failed: ', err);
      dispatch(receivePushSession(err));
    });
};

export const setAacceptedTerms = accepted_terms => ({
  type: SET_ACCEPTED_TERM,
  accepted_terms
});

export const setValidEmail = valid_email => ({
  type: SET_VALID_EMAIL,
  valid_email
});

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case RECEIVE_USER_TOKEN:
      return {...state, user_token: action.user_token}
    case REQUEST_IS_LOGGED_IN:
    case REQUEST_LOGIN:
    case REQUEST_PUSH_SESSION:
      return { ...state, isFetching: true };
    case REQUEST_FAVORITED_VOD:
      return { ...state, groups: action.groups };
    case REQUEST_FAVORITED_CHANNELS:
      return { ...state, channels_groups: action.groups };
    case UPDATE_FAVORITED_VOD:
      const groups = Object.assign([], state.groups);
      if (groups.some(x => x.id == action.group.id) == false)
        groups.unshift({
          id: action.group.id,
          image_small: action.group.image_small,
          title: action.group.title,
          format_types: action.group.format_types,
          proveedor_code: action.group.proveedor_code
        });
      return { ...state, groups };
    case UPDATE_FAVORITED_CHANNELS:
      const channels_groups = Object.assign([], state.channels_groups);
      if (channels_groups.some(x => x.id == action.group.id) == false)
        channels_groups.unshift({
          id: action.group.id,
          image_small: action.group.image_small,
          title: action.group.title,
          live_enabled: action.group.live_enabled
        });
      return { ...state, channels_groups };
    case DELETE_FAVORITED_VOD:
      const value = action.group;
      let g = Object.assign([], state.groups);
      g = g.filter(function(item) {
        return item.id !== value;
      });

      return { ...state, groups: g };
    case DELETE_FAVORITED_CHANNELS:
      const valueChannel = action.group;
      let channels = Object.assign([], state.channels_groups);
      channels = channels.filter(function(item) {
        return item.id !== valueChannel;
      });

      return { ...state, channels_groups: channels };
    case RECEIVE_IS_LOGGED_IN:
    case RECEIVE_LOGIN:
    case RECEIVE_AUTHDEVICE:
      const { user } = action;
      const isLoggedIn =
        user.is_user_logged_in !== undefined ? !!user.is_user_logged_in : !!user.user_id; // boolean value
      const isAnonymous = !isLoggedIn;
      const isSusc = isLoggedIn && !!user.hasUserSusc;
      const userStatus = isLoggedIn ? (isSusc ? SUSC : NO_SUSC) : ANONYMOUS;
      const isIptv = user.isIptv || false;
      const type = isIptv ? IPTV : OTT;
      DeviceStorage.setItem('isIptv', isIptv);
      return {
        ...user,
        isIptv,
        isFetching: false,
        isLoggedIn,
        isAnonymous,
        isSusc,
        userStatus,
        type,
        checkShowAlert: true,
        activeProcessLoginBytoken: userStatus === ANONYMOUS ? false : true
      };

    case RECEIVE_IS_LOGGED_IN_TELMEX:
      const userTelmex = action.user;
      return {
        ...userTelmex,
        is_user_logged_in: 1,
        isFetching: false,
        isLoggedIn: true,
        isAnonymous: false,
        isSusc: true,
        userStatus: NO_SUSC,
        type: OTT
        // subscriptions: { AMCO: true },
      };
      break;
    case RECEIVE_SUBSCRIPTION:
      const subscriptions = state.subscriptions ? state.subscriptions : {};
      const actionIsSuscAMCO = Object.keys(action.subscriptions)[0] === 'AMCO';
      subscriptions[Object.keys(action.subscriptions)[0]] =
        action.subscriptions[Object.keys(action.subscriptions)[0]];
      const isSuscAMCO = state.isSusc ? state.isSusc : !!actionIsSuscAMCO;

      let superhighlight = state.superhighlight.map(item => {
        if (actionIsSuscAMCO && item === NO_SUSC) {
          return SUSC;
        }

        return item;
      });

      if (actionIsSuscAMCO) {
        superhighlight = superhighlight.filter(item => {
          return !item.toUpperCase().includes('AMCO');
        });
      }

      return {
        ...state,
        isSusc: isSuscAMCO,
        userStatus: SUSC,
        superhighlight,
        subscriptions
      };
    case RECEIVE_LOGIN_DYNAMIC:
      action.user.type = action.user.hasSubscription ? 2 : 1;
      return {
        ...state,
        musicUser: action.user
      };
    case SET_LASTTOUCH_SEEN:
      return {
        ...state,
        lasttouch: {
          ...state.lasttouch,
          seen: action.lasttouch
        }
      };
    case SET_LASTTOUCH_FAVORITED:
      return {
        ...state,
        lasttouch: {
          ...state.lasttouch,
          favorited: action.lasttouch
        }
      };
    case SET_LASTTOUCH_PROFILE:
      return {
        ...state,
        lasttouch: {
          ...state.lasttouch,
          profile: action.lasttouch
        }
      };
    case SET_LASTTOUCH_REMINDER:
      return {
        ...state,
        lasttouch: {
          ...state.lasttouch,
          reminder: action.lasttouch
        }
      };

      case SET_LASTTOUCH_LIVECHANNEL:
        return {
          ...state,
          lasttouch: {
            ...state.lasttouch,
            livechannel: action.lasttouch
          }
        };
    case ACTIVE_MARQUEE:
      console.log('[TimeOutAAF] ACTIVE_MARQUEE', action.activeMarquee);
      return {
        ...state,
        activeMarquee: action.activeMarquee
      };
    case RECEIVE_PUSH_SESSION:
      return { ...state, ...state, push_session: action.result };
    case SET_ACCEPTED_TERM:
      return {
        ...state,
        accepted_terms: action.accepted_terms
      };
    case SET_VALID_EMAIL:
        return {
          ...state,
          validEmail: action.valid_email
        };
    case CONTINUE_PROCESS_LOGIN_BY_TOKEN:
      console.log('[AUTHDEVICEV1]:: CONTINUE_PROCESS_LOGIN_BY_TOKEN', action.activeProcessLoginBytoken);
      return {
        ...state,
        activeProcessLoginBytoken: action.activeProcessLoginBytoken
      };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/user.js